module.exports = __webpack_public_path__ + "static/media/mentorSHPEOp.837454fe.png";